import {useCartUI} from '@components/cart/CartSideCartUiProvider';
import {useState} from 'react';
import {useDatabaseCartProviderV3} from '@components/cart/CartProvider';
import {readCookie} from '@components/widgets/Cookies';
import {AddToCart_GA4} from '@components/datalayer/google';
import {Spinner} from '@components/widgets/Common';
import {CheckMarkAnimation} from '@components/product/mobile/CheckMarkAnimation';
import {AddToCart_ADWORDS} from '@components/datalayer/adwords';

let addToCartQueue = Promise.resolve(); // Initialize an empty promise to start the queue
let operationsCount = 0;

export const FreqBoughtTogetherAddToCartButton = ({
                                                    selectedVariant,
                                                    quantity,
                                                    addToCartButtonSource,
                                                    className,
                                                    disabled,
                                                    children,
                                                    iconSize
                                                  }) => {
  // console.log("[FreqBoughtTogetherAddToCartButton][selectedVariant]:", {selectedVariant});
  const {openCart} = useCartUI();
  const [isLoading, setLoading] = useState(false);
  const [wasAdded, setWasAdded] = useState(false);
  const {addToCart, isAddingToCart} = useDatabaseCartProviderV3();

  const addToCartHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    operationsCount++;

    try {
      const cookieSaVisitor = readCookie('sa_visitor');
      const cookieCartToken = readCookie('sa_cart_token');

      const payload = {
        item: {
          sku: selectedVariant?.sku,
          quantity: quantity,
          product_id: selectedVariant?.id,
          price: selectedVariant?.price,
          price_map: selectedVariant?.price_map,
          price_msrp: selectedVariant?.price_msrp,
          price_dealer: selectedVariant?.price_dealer,
          source: 'frequently-bought-together'
        },
        cookieCartToken,
        cookieSaVisitor
      };

      if (addToCartButtonSource) {
        payload.addToCartButtonSource = addToCartButtonSource;
      }
      await addToCart(payload);
      AddToCart_GA4(payload);
      AddToCart_ADWORDS(payload);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
      setWasAdded(true);
      openCart();

      setTimeout(() => {
        setWasAdded(false);
      }, 2000);
    }

  };

  const isButtonDisabled = disabled || isLoading || isAddingToCart;

  return (
    <button
      onClick={addToCartHandler}
      className={className + ' flex align-center justify-center gap-3 whitespace-pre'}
      disabled={isButtonDisabled}>
      {isLoading && (
        <div>
          <Spinner size={iconSize} />
        </div>
      )}
      {wasAdded && (
        <div>
          <CheckMarkAnimation size={iconSize} render={true} />
        </div>
      )}
      {children}
    </button>
  );
};
